const pluralize = (amount, str) => {
  if (amount && amount > 1) return str + 's';
  else return str;
};

export default pluralize;
